import { MainMenuLink, SwitchLink } from '@type/header-types';
import {
  CurrencyDollarIcon, Squares2X2Icon, BriefcaseIcon, UserGroupIcon, PhoneIcon,
} from '@heroicons/react/20/solid';
import { showVoiceAgentModalWithAuth } from '@utils/voice-agent/showVoiceAgentModalWithAuth';
import { audioInterviewConfig } from '@components/templates/audio-interview/config/audioInterviewConfig';

// MAIN MENU LINKS
// forRole:
// NONE - for all, when they are not logged-in
// USER - for authenticated users with role 'USER'
// COMPANY - for authenticated users with role 'COMPANY'

// type:
// symfony - link to symfony route
// react - link to react route
// external - link to external route

// forSection
// TALENT - Represents the talent-related section.
// HIRE - Represents the hiring-related section.
// *******************************************************************

const getCurrentLocale = (): Locale => {
  if (typeof window === 'undefined') return 'ro';
  const pathSegments = window.location.pathname.split('/').filter(Boolean);
  return (['ro', 'en', 'hu'].includes(pathSegments[0]) ? pathSegments[0] : 'ro') as Locale;
};

export const mainMenuLinks: MainMenuLink[] = [
  { // job list page
    route: '/job/list',
    type: 'react',
    label: 'header.label.jobs',
    forSection: ['TALENT', 'HIRE'],
    onlyMobile: false,
    icon: Squares2X2Icon,
    dataTestId: 'navbar-job-list',
  },
  {
    route: '/cv/search',
    type: 'react',
    label: 'header.label.cv_search',
    forSection: ['TALENT', 'HIRE'],
    onlyMobile: false,
    icon: UserGroupIcon,
  },
  {
    route: '/my-jobs',
    label: 'hire.menu',
    type: 'react',
    forSection: ['TALENT', 'HIRE'],
    onlyMobile: false,
    icon: BriefcaseIcon,
    dataTestId: 'navbar-cv-search',
    children: [
      { // company job list page
        route: '/my-jobs',
        label: 'header.label.jobs.v2',
        type: 'react',
        forSection: ['TALENT', 'HIRE'],
        onlyMobile: false,
        dataTestId: 'navbar-my-jobs',
      },
      {
        // add job
        route: '/job-add/edit',
        label: 'header.label.add_jobs',
        type: 'react',
        forSection: ['TALENT', 'HIRE'],
        onlyMobile: false,
        dataTestId: 'navbar-add-job',
        hasDiscount: true,
      },
      {
        // services page
        route: '/company/offer',
        label: 'header.label.pricing',
        type: 'react',
        forSection: ['TALENT', 'HIRE'],
        onlyMobile: false,
        dataTestId: 'navbar-services',
      },
      {
        route: '#',
        label: 'global.support.phoneNr',
        type: 'external',
        forSection: ['TALENT', 'HIRE'],
        onlyMobile: false,
        onlyDesktop: true,
        dataTestId: 'navbar-client-support',
        onClick: () => {
          showVoiceAgentModalWithAuth(
            audioInterviewConfig.elevenlabs.companyAgentId,
            getCurrentLocale(),
          );
        },
      },
      {
        route: '#',
        label: '',
        icon: PhoneIcon,
        type: 'external',
        forSection: ['TALENT', 'HIRE'],
        onlyMobile: true,
        onlyDesktop: false,
        dataTestId: 'navbar-client-support',
        onClick: () => {
          showVoiceAgentModalWithAuth(
            audioInterviewConfig.elevenlabs.companyAgentId,
            getCurrentLocale(),
          );
        },
      },
    ],
  },
  { // cv worth page
    route: '/salaries',
    label: 'global.label.salaries',
    type: 'react',
    forSection: ['TALENT', 'HIRE'],
    onlyMobile: false,
    onlyDesktop: true,
    icon: CurrencyDollarIcon,
    dataTestId: 'navbar-salaries',
  },
];


// SWITCH LINK - between company and user
// *******************************************************************
export const switchLink: SwitchLink = {
  notAuth: { // to add job
    route: '/job-add/edit',
    label: 'header.label.add_jobs',
  },
  authUser: { // change to company account
    route: 'account_user_type',
    label: 'header.switch.hire',
  },
  authCompany: { // change to user account
    route: 'account_user_type',
    label: 'header.switch.work',
  },
};
